"use client";
import React, { useContext, createContext, useState } from "react";
import PropTypes from "prop-types";

export const BrochureStateContext = createContext();
export const BrochureUpdateContext = createContext();

export const BrochureProvider = ({ children }) => {
  const [isShown, setIsShown] = useState(false);

  const state = {
    isShown,
  };

  const updateFns = {
    setIsShown,
  };

  return (
    <BrochureUpdateContext.Provider value={updateFns}>
      <BrochureStateContext.Provider value={state}>
        {children}
      </BrochureStateContext.Provider>
    </BrochureUpdateContext.Provider>
  );
};

export function useBrochureState() {
  const state = useContext(BrochureStateContext);

  if (state === undefined) {
    throw new Error("useBrochureState must be used within a BrochureProvider");
  }

  return state;
}

export function useBrochureUpdate() {
  const updateFns = useContext(BrochureUpdateContext);

  if (updateFns === undefined) {
    throw new Error(
      "BrochureUpdateContext must be used within a BrochureProvider"
    );
  }

  return updateFns;
}

BrochureProvider.propTypes = {
  children: PropTypes.element.isRequired,
};
